import React from 'react';
import { Image, Text, View } from '@react-pdf/renderer';
import { formatPdfEur } from './formatPdfCurrency';
import { usePdfStyles } from './PdfPrintScaleContext';

/** @param {{ lines: Array<{ name: string; description?: string; imageUrl?: string; sku: string; qty: number; unitPrice: number; lineTotal: number }> }} props */
export function CartLinesPdfTable({ lines }) {
    const pdfStyles = usePdfStyles();
    return (
        <View style={pdfStyles.table}>
            <View style={pdfStyles.tableHead} fixed>
                <Text style={[pdfStyles.thName, { fontWeight: 'bold' }]}>Item</Text>
                <Text style={[pdfStyles.thSku, { fontWeight: 'bold' }]}>SKU</Text>
                <Text style={[pdfStyles.thQty, { fontWeight: 'bold' }]}>Qty</Text>
                <Text style={[pdfStyles.thPrice, { fontWeight: 'bold' }]}>Price</Text>
                <Text style={[pdfStyles.thTotal, { fontWeight: 'bold' }]}>Total</Text>
            </View>
            {(lines || []).map((ln, idx) => (
                <View
                    style={[pdfStyles.tableRow, { alignItems: 'flex-start' }]}
                    key={`${ln.sku}-${idx}`}
                    wrap={false}
                >
                    <View style={pdfStyles.itemCell}>
                        {ln.imageUrl ? (
                            <Image src={ln.imageUrl} style={pdfStyles.itemThumb} />
                        ) : (
                            <View style={pdfStyles.itemThumbPlaceholder} />
                        )}
                        <View style={pdfStyles.itemTextCol}>
                            <Text style={pdfStyles.itemName}>{ln.name}</Text>
                            {ln.description ? (
                                <Text style={pdfStyles.itemDesc}>{ln.description}</Text>
                            ) : null}
                        </View>
                    </View>
                    <Text style={[pdfStyles.thSku, pdfStyles.tdMuted]}>{ln.sku}</Text>
                    <Text style={[pdfStyles.thQty, { marginTop: 2 }]}>{String(ln.qty)}</Text>
                    <Text style={[pdfStyles.thPrice, { marginTop: 2 }]}>{formatPdfEur(ln.unitPrice)}</Text>
                    <Text style={[pdfStyles.thTotal, { marginTop: 2 }]}>{formatPdfEur(ln.lineTotal)}</Text>
                </View>
            ))}
        </View>
    );
}
